export const DEFAULT_TIPS = 'Please upload a JPG or PNG image with a file size of less than 2 MB';
